import { TStoryDefaults } from './StoryDefaultsProvider.types';

export const BASE_CANVAS_HEIGHT = 800;

export const DEFAULT_STORY_DEFAULTS: TStoryDefaults = {
  accentColor: '#5A00FE',
  frameBackground: '#181824',
  fontFamily: 'Inter',
  textColor: '#F4F5F8',
  textSizes: {
    title: 24,
    subtitle: 18,
    body: 16,
  },
  cta: {
    color: '#FEFEFE',
    height: 48,
    borderRadius: 32,
  },
};
